export const getFirstTwoChars = (val: string): string => {
  if (val.length < 2) {
    return val;
  }
  return val.substring(0, 2);
};

export const capitalizeFirstLetter = (val: string): string => {
  if (val.length === 0) {
    return val;
  }
  if (val.length === 1) {
    return val.toUpperCase();
  }
  return val.charAt(0).toUpperCase() + val.slice(1);
};

/**
 * Creates a URL-friendly slug from a string.
 * - Converts to lowercase
 * - Replaces accented characters with ASCII equivalents
 * - Replaces spaces and special characters with hyphens
 * - Removes consecutive hyphens
 * - Trims hyphens from start and end
 */
export const createSlug = (val: string): string => {
  return val
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/-+/g, '-') // Remove consecutive hyphens
    .replace(/^-|-$/g, ''); // Trim hyphens from start and end
};
